module.exports = __webpack_public_path__ + "d1ef098bf6aa6b01f9adb9af4fe12210.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/cancel-light.svg
// module id = 1265
// module chunks = 74